import * as React from 'react';

import TopicListing from './topicListing';
import AddTopic from './addTopic';

import BasePage from "pages/common/basePage";
import Header from "pages/common/header";
import MainContent from "pages/common/mainContent";

import "../styles/topics.sass";

class TopicManagementPage extends React.Component<{}, {}> {
    public render() {
        return (
            <BasePage fullWidth>
                <Header
                    title="Manage Topics"
                    rightComponent={<AddTopic />}
                />
                <MainContent>
                    <div className="authoring-page">
                        <TopicListing />
                    </div>
                </MainContent>
            </BasePage>
        );
    }
}

export default TopicManagementPage;